import { computed } from "vue";
import { createQuery } from "@/queries";
import { getUserParameters } from "@/features/parameters/api/parameters";
import type { UserParametersResponse } from "@/types/parameters";
import type { AxiosResponse } from "axios";

type ParametersResponse = Awaited<
  ReturnType<typeof getUserParameters>
> extends AxiosResponse<infer T>
  ? T
  : never;

export const useUserParametersQuery = () => {
  return createQuery<ParametersResponse>({
    key: computed(() => ["user-parameters"]),
    fetcher: async () => {
      const response = await getUserParameters();
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: computed(() => true),
  });
};

